export default "__VITE_ASSET__1ee5a70b__"